import * as React from "react";
import * as $ from 'jquery';

export interface ScrollToErrorProps { 
  isValid : any;
  isSubmitting : any;
}

export default class ScrollToError extends React.Component<ScrollToErrorProps> {
  componentDidUpdate(prevProps : any) {

    if (prevProps.isSubmitting && !this.props.isSubmitting && !this.props.isValid) {
      if ($(".is-invalid.form-control,.is-invalid.custom-control-input").length == 0) {
        return;
      }
      $(".is-invalid.form-control,.is-invalid.custom-control-input")[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  render() : any {
    return null;
  }
}